<template>
  <div class="col-5">
    <slot />
  </div>
</template>
